export default "__VITE_ASSET__tYvEqCor__"